import { Level, PermissionType } from "#types/code-generator.ts";

export function canViewSettings(user: {
  permissions: PermissionType[];
  level: Level;
}) {
  if (!user) {
    return false;
  }

  const isSalesOrAbove =
    user.level === Level.Sales || user.level === Level.SuperAdmin;

  return (
    user.permissions.includes(PermissionType.AccessAdvancedSetting) ||
    isSalesOrAbove
  );
}
